export enum DefaultCapacityRatioType {
  DEFAULT = 35,
}

export const DefaultCapacityRatioTags = {
  [DefaultCapacityRatioType.DEFAULT]: "Default Capacity (Density = 1/35)",
};
